export default __webpack_public_path__ + "static/media/braces.bd306463.svg";